import MfaUserExtensionReadonly from 'Models/Identity/MfaUserExtension';

interface UserEdit {
   userId?: string;
   userName: string;
   fullName: string;
   emailAddress: string;
   roleCode: string;
   isDisabled: boolean;
   isLockedOut: boolean;
   mfaDetails?: MfaUserExtensionReadonly | null;
}

type UserEditModel = Readonly<UserEdit>;

export default UserEditModel;

export const DefaultUserEditModel: UserEditModel = {
   userName: '',
   fullName: '',
   emailAddress: '',
   roleCode: '',
   isDisabled: false,
   isLockedOut: false,
};
